<template>
    <div>
        <div style="place-items: center;margin-right:2%;display: flex;align-items: center;">{{ 111111111 }}
            <el-button style='margin: 10px;' type="primary" icon="document" @click="openDia()">添加管理员</el-button>
        </div>

        <el-dialog title="添加管理员" :visible.sync="dialogFormVisible" center>
            <div class="dialog-content">
                <div style="margin-bottom: 10px; text-align: center;">
                    <el-input v-model="nickName" style="width:50%; display: inline-block;"
                        placeholder="输入管理员名字进行搜索"></el-input>
                    <el-button style="margin: 10px;" type="primary" icon="document" @click="">搜索</el-button>
                </div>
            </div>
           

        </el-dialog>
    </div>
</template>

<script>

import { getTeamAdminLists, getAdminUserList } from '../../../api/manage/team.js'

import moment from 'moment';

export default {
    data() {
        return {
            teamId: '',
            dialogFormVisible: false,
            nickName: '',
            userList: []
        }
    },
    components: {

    },

    created() {
        this.teamId = this.$route.query.teamId
        this.dataSelect()
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {


        dataUserSelect() {
            let post = {
                page: 0,
                size: 100,
                nickName: this.nickName
            }
            getAdminUserList(post).then((res) => {
                if (res.code == 200) {
                    this.userList = res.data.list
                    return;
                }
                this.$message({
                    type: "info",
                    message: res.msg,
                });
            })
        },
        openDia() {
            this.dialogFormVisible = true;
            this.dataUserSelect();
        },

        dataSelect() {
            let post = {
                teamId: this.teamId
            }
            getTeamAdminLists(post).then((res) => {
                if (res.code == 200) {

                    return;
                }
                this.$message({
                    type: "info",
                    message: res.msg,
                });
            })

        },

    }
}
</script>

<style scoped>
.userRole {
    width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/manage/team/admin.vue